import { RbacPermissionsConstant } from '../../../../core/services/rbac/rbac-permissions.constant';
import { RbacServiceInterface } from '../../../../core/services/rbac/rbac-service.interface';

const sortFn = (a: ISettings, b: ISettings) => a.title.localeCompare(b.title);

const PARAMETERS: ISettings[] = [
  {
    title: $localize`:@@settings.offer_goals:Offer Goals`,
    description: $localize`:@@settings.offer_goals_description:Offer Goal describes what kind of target action counts as a conversion in each specific offer.`,
    link: '/app/settings/crm-offer-goals',
    permission: RbacPermissionsConstant.PAGES_TABLE_GOALS,
    icon: 'menu-external',
  },
  {
    title: $localize`:@@settings.affiliate_groups:Affiliate Groups`,
    description: $localize`:@@settings.affiliate_groups_description:Create an affiliate group overseen by a master affiliate.`,
    link: '/app/settings/crm-affiliate-groups',
    permission: RbacPermissionsConstant.PAGES_TABLE_AFFILIATE_GROUP,
    icon: 'workers',
  },
  {
    title: $localize`:@@settings.crm_metrics:CRM Metrics`,
    description: $localize`:@@settings.crm_metrics_description:Add custom data points to evaluate general and highly specific events, actions or results across the CRM.`,
    link: '/app/settings/crm-metrics',
    permission: RbacPermissionsConstant.WORKFLOW_SECTION,
    icon: 'menu-folders',
  },
  {
    title: $localize`:@@settings.crm_settings:CRM Settings`,
    description: $localize`:@@settings.crm_settings_description:Configure in details what should be included in CRM’s representation.`,
    link: '/app/settings/crm-settings',
    permission: RbacPermissionsConstant.PAGES_SPECIAL_CRM_SETTINGS,
    icon: 'menu-tools',
  },
  {
    title: $localize`:@@settings.tracking_domains:Tracking Domains`,
    description: $localize`:@@settings.tracking_domains_description:Add a resource for tracking.`,
    link: '/app/settings/crm-tracking-domains',
    permission: RbacPermissionsConstant.PAGES_TABLE_TRACKING_DOMAINS,
    icon: 'menu-folders',
  },
  {
    title: $localize`:@@settings.presets:Presets`,
    description: $localize`:@@settings.presets_description:Configure a set of options that you can later access in Data Exporter, Drilldown, Comparing Analytics, and Offer Descriptions.`,
    link: '/app/settings/crm-presets-list',
    permission: [RbacPermissionsConstant.PAGES_SPECIAL_DRILLDOWN, RbacPermissionsConstant.PAGES_SPECIAL_REPORT_BUILDER],
    icon: 'menu-folders',
  },
  {
    title: $localize`:@@settings.api_tokens:API Tokens`,
    description: $localize`:@@settings.api_tokens_description:Create an API token to access the CRM’s API via an external system.`,
    link: '/app/settings/crm-tokens',
    permission: RbacPermissionsConstant.PAGES_TABLE_TOKENS,
    icon: 'menu-folders',
  },
  {
    title: $localize`:@@settings.affiliate_area:Affiliate Area`,
    description: $localize`:@@settings.affiliate_area_description:Manage permissions for affiliates.`,
    link: '/app/settings/crm-affiliate-area',
    permission: RbacPermissionsConstant.PAGES_SPECIAL_ACCESS_CONTROLS,
    icon: 'menu-external',
  },
  {
    title: $localize`:@@settings.advertiser_area:Advertiser Area`,
    description: $localize`:@@settings.advertiser_area_description:Manage permissions for advertisers.`,
    link: '/app/settings/crm-advertiser-area',
    permission: RbacPermissionsConstant.PAGES_SPECIAL_ACCESS_CONTROLS,
    icon: 'menu-tools',
  },
  {
    title: $localize`:@@settings.goal_types:Goal Types`,
    description: $localize`:@@settings.goal_types_description:Categorize goals to run special payment rules and get precise statistics.`,
    link: '/app/settings/crm-goal-types',
    permission: RbacPermissionsConstant.PAGES_TABLE_GOAL_TYPES_TABLE,
    icon: 'workers',
  },
  {
    title: $localize`:@@settings.payout_business_models:Payout Business Models`,
    description: $localize`:@@settings.payout_business_models_description:Configure a formula for payout which you can use in various  payout rules.`,
    link: '/app/settings/crm-payout-models',
    permission: RbacPermissionsConstant.PAGES_TABLE_PAYOUT_BUSINESS_MODEL,
    icon: 'managment-2',
  },
  {
    title: $localize`:@@settings.revenue_business_models:Revenue Business Models`,
    description: $localize`:@@settings.revenue_business_models_description:Configure a formula for revenue which you can use in various  revenue rules.`,
    link: '/app/settings/crm-revenue-models',
    permission: RbacPermissionsConstant.PAGES_TABLE_REVENUE_BUSINESS_MODEL,
    icon: 'menu-tools',
  },
  {
    title: $localize`:@@settings.crm_documents:CRM Documents`,
    description: $localize`:@@settings.crm_documents_description:Create a sign up agreement for all affiliates.`,
    link: '/app/settings/crm-documents',
    permission: RbacPermissionsConstant.PAGES_TABLE_CRM_DOCUMENTS,
    icon: 'menu-external',
  },
  {
    title: $localize`:@@settings.crm_questions:CRM Questions`,
    description: $localize`:@@settings.crm_questions_description:Create a questionnaire for affiliates to ensure they fit your requirements.`,
    link: '/app/settings/crm-questions',
    permission: RbacPermissionsConstant.PAGES_TABLE_CRM_QUESTIONS,
    icon: 'workers',
  },
  {
    title: $localize`:@@settings.affiliate_manager:Affiliate Manager`,
    description: $localize`:@@settings.affiliate_manager_description:Assign Affiliate Manager to a group of affiliates.`,
    link: '/app/settings/crm-affiliate-manager',
    permission: RbacPermissionsConstant.PAGES_TABLE_AFFILIATE_MANAGERS,
    icon: 'menu-tools',
  },
  {
    title: $localize`:@@settings.notification_settings:Notification Settings`,
    description: $localize`:@@settings.notification_settings_description:Enable notifications for email, Telegram`,
    link: '/app/settings/crm-notification-settings',
    permission: RbacPermissionsConstant.WIDGETS_NOTIFICATIONS_SETTINGS,
    icon: 'menu-notification',
  },
  {
    title: $localize`:@@settings.advertiser_brands:Advertiser Brands`,
    description: $localize`:@@settings.advertiser_brands_description:Group several advertisers into a single brand.`,
    link: '/app/settings/crm-advertiser-brands',
    permission: RbacPermissionsConstant.PAGES_TABLE_ADVERTISER_BRANDS,
    icon: 'managment-2',
  },
  {
    title: $localize`:@@settings.affiliate_kyc:Affiliate KYC`,
    description: $localize`:@@settings.affiliate_kyc_description:Set up a document flow between you and affiliates.`,
    link: '/app/settings/crm-affiliate-kyc-schema',
    permission: RbacPermissionsConstant.PAGES_TABLE_SCHEMA_STEPS,
    icon: 'menu-affilate',
  },
  {
    title: $localize`:@@settings.pulling_mappings:Pulling Mappings`,
    description: $localize`:@@settings.pulling_mappings_description:Determine how to map pulled conversions from the advertiser’s source and record them in the CRM.`,
    link: '/app/settings/crm-pulling-mappings',
    permission: RbacPermissionsConstant.PAGES_TABLE_PULLING_MAPPINGS,
    icon: 'menu-affilate',
  },
  {
    title: $localize`:@@settings.import_csv:Import CSV`,
    description: $localize`:@@settings.import_csv_description:Import conversions from a CSV file to the CRM.`,
    link: '/app/settings/crm-import-csv',
    permission: RbacPermissionsConstant.WIDGETS_CSV_FIELDS,
    icon: 'reporting-conversion',
  },
  {
    title: $localize`:@@settings.conversion_profile:Conversion Profile`,
    description: $localize`:@@settings.conversion_profile_description:Add custom fields for conversions.`,
    link: '/app/settings/crm-conversion-profile',
    permission: RbacPermissionsConstant.PAGES_TABLE_CONVERSION_PROFILE_CONSTRUCTOR,
    icon: 'workers',
  },
  {
    title: $localize`:@@settings.referral_programs:Referral Programs`,
    description: $localize`:@@settings.referral_programs_description:Configure referral rewards and list the types of conversions and geolocations available for referral programs.`,
    link: '/app/settings/referral-programs',
    permission: RbacPermissionsConstant.PAGES_TABLE_REFERRAL_PROGRAMS,
    icon: 'workers',
  },
  {
    title: $localize`:@@settings.referral_business_models:Referral Business Models`,
    description: $localize`:@@settings.referral_business_models_description:Set a formula for a referral reward.`,
    link: '/app/settings/referral-business-models',
    permission: RbacPermissionsConstant.PAGES_TABLE_REFERRAL_PAYOUT_BUSINESS_MODEL,
    icon: 'menu-tools',
  },
  {
    title: $localize`:@@currency.provider:Currency Provider`,
    description: $localize`:@@settings.currency_provider_description:Configure connections with currency providers to get the actual exchange rates.`,
    link: '/app/settings/currency-provider',
    permission: RbacPermissionsConstant.CURRENCY_INTEGRATION_PROFILE,
    icon: 'workers',
  },
  {
    title: $localize`:@@affiliate.consolidation:Affiliate Consolidation`,
    description: $localize`:@@settings.affiliate_invoice_consolidation_description:Combine invoices for several affiliates.`,
    link: '/app/settings/affiliate-invoice-consolidation',
    permission: RbacPermissionsConstant.AFFILIATE_INVOICE_CONSOLIDATION_PAGE,
    icon: 'workers',
  },
];

const CUSTOMIZE: ISettings[] = [
  {
    title: $localize`:@@settings.events_logs:Events Logs`,
    description: $localize`:@@settings.events_logs_description:Events Logs display most of the actions processed by the system, such as bugs, errors, notifications, pushed and rejected leads, and so on. There are Namespace, Message and Type of logs in the table.`,
    link: '/app/settings/crm-events-logs',
    permission: RbacPermissionsConstant.PAGES_TABLE_EVENTS_LOGS,
    icon: 'menu-tools',
  },
  {
    title: $localize`:@@settings.unsecured_mode_logs:Unsecured Mode Logs`,
    description: $localize`:@@settings.unsecured_mode_logs_description:Here you can see the information about employees who used an Unsecured Mode feature. There are user IDs, date and time when Unsecured Mode was activated. Only successful activations of Unsecured Mode with two-step authorization in the system are here.`,
    link: '/app/settings/crm-unsecured-mode-logs',
    permission: RbacPermissionsConstant.PAGES_TABLE_UNSECURED_MODE_LOGS,
    icon: 'menu-tools',
  },
].sort(sortFn);

const TREES: ISettings[] = [
  {
    title: $localize`:@@settings.main_tree:Main Tree`,
    description: $localize`:@@settings.main_tree_description:Main Tree.`,
    link: '/app/settings/crm-main-tree',
    permission: RbacPermissionsConstant.MAIN_TREE,
    icon: 'reporting-conversion',
    rbacType: 'every',
  },
  {
    title: $localize`:@@settings.custom_settings_tree:Custom Settings Tree`,
    description: $localize`:@@settings.custom_settings_tree_description:Custom Settings Tree.`,
    link: '/app/settings/crm-custom-settings-tree',
    permission: RbacPermissionsConstant.AFFILIATE_AREA_SETTINGS_TREE,
    icon: 'settings',
    rbacType: 'every',
  },
  {
    title: $localize`:@@settings.default_settings_tree:Default Settings Tree`,
    description: $localize`:@@settings.default_settings_tree_description:Default Settings Tree.`,
    link: '/app/settings/crm-default-settings-tree',
    permission: RbacPermissionsConstant.AFFILIATE_AREA_SETTINGS_TREE,
    icon: 'settings',
    rbacType: 'every',
  },
  // {
  //   title: 'Manager Assings Tree',
  //   description: `Manager Assings Tree.`,
  //   link: '/app/settings/crm-manager-assings-tree',
  //   permission: RbacPermissionsConstant.COMMANDS_CRM_SETTINGS_EDIT,
  //   icon: 'other-user-outline',
  // },
  // {
  //   title: 'Referral Payouts Tree',
  //   description: `Referral Payouts Tree.`,
  //   link: '/app/settings/crm-referral-payouts-tree',
  //   permission: RbacPermissionsConstant.COMMANDS_CRM_SETTINGS_EDIT,
  //   icon: 'currency',
  // },
  // {
  //   title: 'KYC Assigns Tree',
  //   description: `KYC Assigns Tree.`,
  //   link: '/app/settings/crm-kyc-assigns-tree',
  //   permission: RbacPermissionsConstant.COMMANDS_CRM_SETTINGS_EDIT,
  //   icon: 'reporting-conversion',
  // },
];

const filterFn = (rbacService: RbacServiceInterface) => (item: ISettings) =>
  item.rbacType === 'every' ? rbacService.canEvery(item.permission) : rbacService.can(item.permission);

export const getSettingsContent = (rbacService: RbacServiceInterface): ISettingsType =>
  Object.entries({ PARAMETERS, CUSTOMIZE, TREES }).reduce((acc, [key, value]) => {
    acc[key] = (acc[key] || []).concat(value.filter(filterFn(rbacService)));
    return acc;
  }, {} as ISettingsType);

interface ISettingsType {
  PARAMETERS: typeof PARAMETERS;
  CUSTOMIZE: typeof CUSTOMIZE;
  TREES: typeof TREES;
}

export interface ISettings {
  title: string;
  description: string;
  link: string;
  permission: string | string[];
  rbacType?: string;
  icon: string;
}

export type RbacType = 'every' | 'default';
